import styles from "./Footer.module.css";

const policies = [
  { label: "Return Policy", href: "/return-policy" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms & Conditions", href: "/terms-and-conditions" },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.brand}>
          Ratnapura <span>Gems</span>
        </div>
        <p className={styles.tagline}>Premium Sri Lankan Gems & Jewellery</p>

        <div className={styles.contact}>
          <a href="https://maps.google.com/?q=No+58/A+Colombo+Road+Kurunegala" target="_blank" rel="noopener noreferrer" className={styles.contactItem}>
            📍 No. 58/A, Colombo Road, Kurunegala
          </a>
          <a href="tel:+94765851400" className={styles.contactItem}>
            📞 076 585 1400
          </a>
        </div>

        <div className={styles.divider} />

        <div className={styles.policyLinks}>
          {policies.map(({ label, href }, i) => (
            <span key={label} className={styles.policyGroup}>
              <a href={href} className={styles.policyLink}>{label}</a>
              {i < policies.length - 1 && (
                <span className={styles.dot}>·</span>
              )}
            </span>
          ))}
        </div>

        <div className={styles.divider} />

        <p className={styles.copy}>© 2025 Ratnapura Gems. All rights reserved.</p>
        <p className={styles.sub}>Trusted since 2002 | National Gem & Jewellery Authority licensed</p>
      </div>
    </footer>
  );
}